@if (selectedItem) {
  <form [formGroup]="form" (ngSubmit)="save(selectedItem)">
    <p-panel>
      <p-header>
        @if (selectedItem.id) {
          <h2>Editing '{{originalName}}'</h2>
        }
        @if (!selectedItem.id) {
          <h2>Create New {{entityName}}</h2>
        }
      </p-header>
      <div class="grid flex-row flex-wrap align-content-center justify-content-start">
        <!-- Item specifics start here -->
        <p-tabs class="col-9">
          <p-tablist>
            <p-tab value="0"><i class="fa fa-car"></i>Personal info</p-tab>
          </p-tablist>
          <p-tabpanels>
          <p-tabpanel>
            <div class="grid flex-row">
              <div class="col-6">
                <!-- dividerColor="{{ !form.controls.firstname.valid ? 'warn' : 'primary' }}" -->
                <mat-form-field class="full-width" >
                  <mat-label>First name</mat-label>
                  <input matInput placeholder="First name" class="full-width" type="text" id="firstname" required formControlName="firstname" name="firstname" />
                  @if (!form.controls.firstname.valid) {
                    <mat-hint align="start" [class.alert-danger]="!form.controls.firstname.valid">First name must not be empty</mat-hint>
                  }
                </mat-form-field>
              </div>
              <div class="col-6">
                <!-- dividerColor="{{ !form.controls.lastname.valid ? 'warn' : 'primary' }}" -->
                <mat-form-field class="full-width" >
                  <mat-label>Last name</mat-label>
                  <input matInput placeholder="Last name" class="full-width" type="text" id="lastname" required formControlName="lastname" name="lastname" />
                  @if (!form.controls.lastname.valid) {
                    <mat-hint align="start" [class.alert-danger]="!form.controls.lastname.valid">Last name must not be empty</mat-hint>
                  }
                </mat-form-field>
              </div>
              @if (false) {
                <div class="col-3">
                  <mat-form-field class="full-width">
                    <mat-label>Password</mat-label>
                    <input matInput placeholder="Password" class="full-width" type="password" id="password1" formControlName="password1" name="password1" />
                  </mat-form-field>
                </div>
              }
              @if (false) {
                <div class="col-3">
                  <mat-form-field class="full-width">
                    <mat-label>Confirm password</mat-label>
                    <input matInput placeholder="Confirm password" class="full-width" type="password" id="password2" formControlName="password2" name="password2" />
                  </mat-form-field>
                </div>
              }
              <div class="col-6">
                <mat-form-field class="full-width">
                  <mat-label>Phone</mat-label>
                  <input matInput placeholder="Phone" class="full-width" type="text" formControlName="phone" name="phone" />
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="full-width">
                  <mat-label>E-mail</mat-label>
                  <input matInput placeholder="E-mail" class="full-width" required type="text" formControlName="email" name="email" />
                  @if (!form.controls.email.valid) {
                    <mat-hint align="start" [class.alert-danger]="!form.controls.email.valid">E-mail must not be empty</mat-hint>
                  }
                </mat-form-field>
              </div>
              @if (showCompany) {
                <div class="col-6" >
                  <mat-select class="full-width" placeholder="Company" formControlName="tfCompanyId" required>
                    @for (company of tfCompanies; track company) {
                      <mat-option [value]="company.id">{{ company.name }}</mat-option>
                    }
                  </mat-select>
                </div>
              }
            </div>
          </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
        <div class="col-3">
          <p>Roles <span style="color:red">*</span>:</p>
          <p-listbox [options]="(roles$ | async) || []" required formControlName="roles" [multiple]="true" [checkbox]="true" [filter]="true"
          optionLable="label" optionValue="value" ></p-listbox>
        </div>
        <!-- Item specifics end here -->
      </div>
      <div class="clearfix"></div>
      @if (errorMsgs?.length) {
        <ul class="col-12" class="alert alert-danger">
          @for (err of errorMsgs; track err) {
            <li>{{err}}</li>
          }
        </ul>
      }
      <p-footer>
        <button mat-raised-button color="primary" type="submit" [disabled]="!isValid">Submit</button>
        <button mat-raised-button (click)="cancel(selectedItem)" type="button">Cancel</button>
      </p-footer>
    </p-panel>
  </form>
}

@if (debug) {
  <div class="col-12">
    <pre>{{ debug | json }}</pre>
  </div>
}

@if (!selectedItem) {
  <div>{{entityName}} does not exists</div>
}

